import React from 'react';
import { motion } from 'framer-motion';
import { Check, Lock, Zap } from 'lucide-react';
export function Pricing() {
  const features = ['MegaPack Primaria — 6 tomos completos', 'MegaPack Secundaria — 6 tomos completos', '6 Bonos exclusivos incluidos', 'Acceso inmediato', 'Garantía de 7 días'];
  return <section id="pricing" className="py-24 lg:py-32 bg-paper-alt relative overflow-hidden" data-id="element-187">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-188">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-12" data-id="element-189">
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-terra-50 text-terra-600 font-medium text-xs uppercase tracking-widest mb-8 border border-terra-100" data-id="element-190">
            <Zap className="w-4 h-4 text-terra-500" data-id="element-191" />
            OFERTA LANZAMIENTO · 2X1
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium text-ink-800 tracking-tight leading-tight" data-id="element-192">
            Reservá tu acceso al{' '}
            <span className="text-brand-500" data-id="element-193">Sistema Arte Lista 2026</span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="bg-paper-card rounded-[24px] p-8 md:p-14 shadow-card border border-paper-border relative max-w-xl mx-auto" data-id="element-194">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-500 text-white font-medium px-6 py-2 rounded-full text-xs uppercase tracking-widest shadow-sm whitespace-nowrap" data-id="element-195">
            Acceso completo
          </div>

          <div className="text-center mb-10 pt-4" data-id="element-196">
            <div className="text-ink-800 font-serif font-medium text-2xl mb-2" data-id="element-197">
              Sistema Profesional Arte Lista 2026
            </div>
            <p className="text-ink-600 text-sm mb-8 font-normal" data-id="element-198">
              MegaPack Primaria + MegaPack Secundaria + 6 Bonos + Garantía de 7
              días
            </p>

            <div className="mb-3 flex items-center justify-center gap-4" data-id="element-199">
              <span className="text-ink-400 line-through text-2xl font-medium" data-id="element-200">
                $39.980
              </span>
              <span className="bg-accent-100 text-accent-700 font-medium text-xs px-3 py-1.5 rounded-full uppercase tracking-widest" data-id="element-201">
                -50%
              </span>
            </div>
            <div className="text-5xl sm:text-6xl md:text-7xl font-serif font-medium text-brand-500 mb-3 tracking-tight" data-id="element-202">
              $19.990
            </div>
            <p className="text-sm text-ink-500 font-normal" data-id="element-203">
              Pago único · Sin suscripción
            </p>
          </div>

          <div className="space-y-4 mb-10 bg-paper-main rounded-[20px] p-8 border border-paper-border" data-id="element-204">
            {features.map((feature, i) => <div key={i} className="flex items-center gap-4" data-id="element-205">
                <div className="w-6 h-6 rounded-full bg-accent-100 text-brand-500 flex items-center justify-center shrink-0" data-id="element-206">
                  <Check className="w-3.5 h-3.5" strokeWidth={2} data-id="element-207" />
                </div>
                <span className="text-ink-800 font-medium text-base" data-id="element-208">
                  {feature}
                </span>
              </div>)}
          </div>

          <a href="https://edu.iterapro.shop/cart/44557485572189:1" className="block w-full text-center bg-brand-500 hover:bg-brand-600 text-white font-medium py-5 px-6 rounded-2xl transition-colors duration-300 shadow-cta text-lg tracking-wide" data-id="element-209">
            QUIERO MI SISTEMA ARTE LISTA 2026
          </a>

          <p className="text-center text-xs text-ink-500 mt-6 inline-flex items-center justify-center gap-2 w-full font-normal" data-id="element-210">
            <Lock className="w-3.5 h-3.5" data-id="element-211" />
            Pago 100% seguro · Mercado Pago · Tarjeta · Transferencia
          </p>
        </motion.div>
      </div>
    </section>;
}